import type { VolcanoStepTemplate } from '../types/volcano.types';

/**
 * Convert a Mongo-backed step template document to ReactFlow node info.
 * Keeps UI node-data shape aligned across palette + library insertion.
 */
export function stepTemplateToNode(template: VolcanoStepTemplate): {
  nodeType: string;
  nodeData: any;
  templateId: string;
} {
  const nodeType = template?.node_type || 'llmStep';
  const step: any = template?.step || {};

  const nodeData = (() => {
    if (nodeType === 'llmStep') {
      return {
        stepName: step.name || template.name || 'LLM Step',
        prompt: step.prompt || '',
        provider: step.provider || 'anthropic',
        model: step.model || 'claude-sonnet-5',
        costEstimate: '<$0.001',
        input: step.input,
      };
    }
    if (nodeType === 'httpStep') {
      return {
        stepName: step.name || template.name || 'HTTP Step',
        url: step.url,
        method: step.method || 'POST',
        description: template.description || step.description,
        continueOnError: step.continue_on_error,
        condition: step.condition,
        timeout: step.timeout,
      };
    }
    if (nodeType === 'toolCall') {
      // Map volcano-engine MCP fields to current ToolCall node fields.
      return {
        toolName: step.mcp_tool || step.tool_name || template.name,
        toolDescription: template.description,
        mcpServer: step.mcp_server,
        parameters: step.input || step.parameters || {},
      };
    }
    if (nodeType === 'agentCall') {
      return {
        agentId: step.agent_id,
        agentName: step.agent_name || template.name || step.agent_id,
        agentDescription: template.description,
        domain: step.domain,
        workflow: step.workflow,
        input: step.input,
      };
    }
    if (nodeType === 'transformStep') {
      return {
        stepName: step.name || template.name || 'Transform',
        transform: step.transform,
      };
    }
    if (nodeType === 'validateStep') {
      return {
        stepName: step.name || template.name || 'Validate',
        schema: step.schema,
        on_error: step.on_error,
        input: step.input,
      };
    }
    if (nodeType === 'notifyStep') {
      return {
        stepName: step.name || template.name || 'Notify',
        channel: step.channel,
        url: step.url,
        payload: step.payload,
      };
    }
    return { ...step };
  })();

  return { nodeType, nodeData, templateId: template.id };
}

